import { DASHBOARD_FILTER_MODAL, DASHBOARD_QUERY } from "constants/ActionTypes";
import {
  fetchGeneralDashboard,
  fetchGlobalDashboard,
  fetchPriorityTestTypeDashboard,
} from "data/actions/Report";
import { useDispatch, useSelector } from "react-redux";

const _useReport = () => {
  const {
    dashboardQuery,
    dashboardFilterModal,
    priorityDashboardList,
    globalDashboardList,
  } = useSelector(({ report }) => report);

  const dispatch = useDispatch();

  const getGeneralDashboard = async (payload) =>
    await dispatch(fetchGeneralDashboard(payload));
  const getGlobalDashboard = async (payload) =>
    await dispatch(fetchGlobalDashboard(payload));
  const getPriorityDashboard = async (payload) =>
    await dispatch(fetchPriorityTestTypeDashboard(payload));

  const setDashboardQuery = (value) =>
    dispatch({ type: DASHBOARD_QUERY, payload: value });

  const setFilterModal = (value) => {
    dispatch({
      type: DASHBOARD_FILTER_MODAL,
      payload: value,
    });
  };

  return {
    dashboardFilterModal,
    priorityDashboardList,
    globalDashboardList,
    dashboardQuery,
    getGeneralDashboard,
    getGlobalDashboard,
    getPriorityDashboard,
    setFilterModal,
    setDashboardQuery,
  };
};

export default _useReport;
